import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import Tabs from '../../../../../Template/layoutComponents/Tabs';

import HistoryTab from '../../../../../Template/layoutComponents/HistoryTab';
import GeneralTab from '../../../../components/GeneralTab';

import { getUsers, newUser, updateUser } from '../../../../../Settings/helpers/apiCalls';
import { useMsal } from '@azure/msal-react';

import useMaintenaceState from '../../../../atoms/variables';
import useGlobalState from '../../../../../Template/atoms/variables';
import { notification } from 'antd';

import './style.css';

const ExecutorDetails = () => {
  const { t } = useTranslation();
  const { executorId } = useParams();

  const [notificationApi, contextHolder] = notification.useNotification();
  const { instance } = useMsal();

  const { setPendingApiCalls } = useGlobalState();

  const { viewDetailsItem, setViewDetailsItem } = useMaintenaceState();

  useEffect(() => {
    if (!viewDetailsItem || !viewDetailsItem.user_id) {
      triggerApiCalls();
    }
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['findUserById']));

      const response = await getUsers(instance);
      const user = response?.items?.find((o) => o.id === executorId || o._id === executorId);
      const account = instance.getAccountByHomeId(user.user_id)?.idTokenClaims;
      setViewDetailsItem({
        ...user,
        label: account?.name ?? `${account?.given_name} ${account?.family_name}`,
      });
    } catch (err) {
      notificationApi.error({
        message: t('database_communication_failure'),
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'findUserById'));
    }
  };

  const updateCurrentEditingItem = (setEditing, allCategories, current, inputIndex, event) => {
    setEditing(true);
    let chosenCategory;
    // Search by current selected ID
    chosenCategory = allCategories?.find((cat) => {
      return cat.id === event.target.value;
    });

    // If not found, search by selected Categoy in 'Categoria' property
    if (!chosenCategory)
      chosenCategory = allCategories?.find((cat) => {
        const catProp = current.properties.find((prop) => prop?.key === 'category' && prop?.main);

        return cat.id === catProp?.value?.id;
      });

    const chosenCategoryProperties = chosenCategory ? [...chosenCategory?.properties] : [];

    let updateName = false;

    return {
      ...current,
      properties: [
        ...current.properties.map((item, index) => {
          if (index === inputIndex) {
            if (item.label.toLowerCase() === 'nome') {
              updateName = event.target.value;
            }

            return {
              ...item,
              value: item.type.toLowerCase().includes('select')
                ? Array.isArray(event.target.value)
                  ? event.target.value.map((value) => ({
                      id: value,
                      label: '',
                    }))
                  : { id: event.target.value, label: '' }
                : item.type.toLowerCase().includes('bool')
                  ? event.target.value
                  : event.target.value,
              // event.target.value?.replace(/ /g, ''),
            };
          }
          return item;
        }),
      ]
        .filter(
          (prop) =>
            prop.main ||
            chosenCategoryProperties.some((currentCatProp) => currentCatProp.label == prop.label),
        )
        .concat(
          chosenCategory?.properties
            ?.filter((prop) => !prop.main)
            .filter(
              (prop) =>
                !current.properties.some(
                  (currentProp) => !currentProp.main && currentProp.label == prop.label,
                ),
            ) ?? [],
        ),
      name: updateName ? updateName : current.name,
    };
  };

  return (
    <div id='categoryDetails'>
      <Tabs
        tabs={[
          {
            label: t('general_tab'),
            content: (
              <GeneralTab
                creating={executorId === 'newUser'}
                goBackTo={'/maintenance/executors'}
                update={updateUser}
                create={newUser}
                updateCurrentEditingItem={updateCurrentEditingItem}
              />
            ),
            disabled: false,
          },
          {
            label: t('history_tab'),
            content: <HistoryTab id={executorId} />,
            disabled: executorId === 'newUser',
          },
        ].filter((tab) => tab)}
      />
    </div>
  );
};

export default ExecutorDetails;
